export const lang: any = {
    jp: {
        term: 'EcoFlowの<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank" rel="noopener noreferrer">利用規約</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に同意します。',
    },
};
